/**

contains functions used by other modules (such as jobsearch, jobcategories.js);

**/

const CareersUtilities = {
	encodedLocation: function(searchLocationText) {
		let output = "";
		searchLocationText = searchLocationText.replace(/&amp;/g, "&");
		for (let f = 0, g = searchLocationText.length; f < g; f++) {
			if (typeof b[searchLocationText[f]] != "undefined") {
				output += b[searchLocationText[f]];
			} else {
				output += encodeURIComponent(searchLocationText[f]);
			}
		}
		output = output
			.toLowerCase()
			.replace(new RegExp("--", "g"), "-")
			.replace(new RegExp("--", "g"), "-");
		//console.log("encodedLocation output: " + output);
		return output;
	},
	encodeSearchTerm: function(searchTerm) {
		let output = "";
		searchTerm = searchTerm.replace(/&amp;/g, "&");
		for (let f = 0, g = searchTerm.length; f < g; f++) {
			if (typeof d[searchTerm[f]] != "undefined") {
				output += d[searchTerm[f]];
			} else {
				output += encodeURIComponent(searchTerm[f]);
			}
		}
		output = output
			.toLowerCase()
			.replace(new RegExp("--", "g"), "-")
			.replace(new RegExp("--", "g"), "-");
		if (output[0] === "-") {
			output = output.substring(1);
		}
		if (output[output.length - 1] === "-") {
			output = output.substring(0, output.length - 1);
		}
		//console.log("encodeSearchTerm output: " + output);
		return output;
	},
	encodeFreeTextSearchTerm: function(searchTerm) {
		if (searchTerm !== undefined) {
			let output = "";
			searchTerm = searchTerm.replace(/&amp;/g, "&");
			for (let f = 0, g = searchTerm.length; f < g; f++) {
				if (typeof a[searchTerm[f]] != "undefined") {
					output += a[searchTerm[f]];
				} else {
					output += encodeURIComponent(searchTerm[f]);
				}
			}
			return output;
		} else {
			return "";
		}
	},
	sortByKey: function(array, key) {
		return array.sort(function(a, b) {
			let x = a[key];
			let y = b[key];
			return x > y ? -1 : x < y ? 1 : 0;
		});
	}
}

const a = {
	"/": "-or-",
	"\\": "-or-",
	".": "-dot-",
	"&": "-and-",
	"+": "-plus-",
	"%": "-perc-",
	"?": "-ques-",
	"#": "-hash-",
	$: "-dlr-",
	"*": "-star-",
	"!": "-mrk-",
	'"': "-quat-",
	"'": "-apos-",
	"<": "-lt-",
	">": "-gt-",
	"|": "-pipe-",
	":": "-cln-"
};

const b = {
	",": "",
	"'": "",
	".": "-",
	"/": "-",
	"(": "-",
	")": "-",
	" ": "-",
	"--": "-"
};

const d = {
	"/": "-",
	".": "-dot-",
	"&": "-and-",
	"+": "-plus-",
	"#": "-hash-",
	'"': "-",
	"'": "",
	":": "-",
	"’": "",
	"(": "",
	")": "",
	",": "-",
	" ": "-"
};


window.CareersUtilities = CareersUtilities;
